module.exports = __webpack_public_path__ + "static/media/Profile.72f05a3e.jpg";